import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';

export type ElementsProviderContextProps = {
  isStripeLoading: boolean;
};

const STRIPE_API_PUBLIC_KEY = process.env.NX_PUBLIC_STRIPE_API_PUBLIC_KEY;

export const ElementsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  if (!STRIPE_API_PUBLIC_KEY) {
    throw new Error('STRIPE_API_PUBLIC_KEY not found!');
  }
  const stripePromise = loadStripe(STRIPE_API_PUBLIC_KEY);
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
